import React from "react";
import { useNavigate } from "react-router-dom";
import { Box, Typography, Button, Divider } from "@mui/material";
import { useAuth } from "../contexts/authContext";

const AccountPage = () => {
  const { user, isAdmin, signOut } = useAuth();
  const navigate = useNavigate();

  const handleSignOut = async () => {
    await signOut();
    navigate("/");
  };

  return (
    <Box sx={{ maxWidth: 600, mx: "auto", px: 4, py: 8 }}>
      <Typography
        variant="h5"
        sx={{
          fontWeight: 700,
          textTransform: "uppercase",
          letterSpacing: "0.1em",
          mb: 4,
        }}
      >
        My Account
      </Typography>

      <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
        <Box>
          <Typography
            variant="caption"
            sx={{
              color: "#737373",
              textTransform: "uppercase",
              letterSpacing: "0.1em",
            }}
          >
            Email
          </Typography>
          <Typography variant="body1" sx={{ mt: 0.5 }}>
            {user?.email}
          </Typography>
        </Box>

        {isAdmin && (
          <Box sx={{ mt: 1 }}>
            <Typography
              variant="caption"
              sx={{
                color: "#737373",
                textTransform: "uppercase",
                letterSpacing: "0.1em",
              }}
            >
              Role
            </Typography>
            <Typography variant="body1" sx={{ mt: 0.5, fontWeight: 600 }}>
              Admin
            </Typography>
          </Box>
        )}
      </Box>

      <Divider sx={{ my: 4 }} />

      <Box sx={{ display: "flex", flexWrap: "wrap", gap: 2 }}>
        <Button
          onClick={() => navigate("/orders")}
          variant="contained"
          sx={{
            bgcolor: "black",
            color: "white",
            px: 3,
            py: 1.25,
            fontSize: "0.75rem",
            letterSpacing: "0.1em",
            "&:hover": { bgcolor: "#333" },
          }}
        >
          Order History
        </Button>
        {isAdmin && (
          <Button
            onClick={() => navigate("/admin")}
            variant="contained"
            sx={{
              bgcolor: "black",
              color: "white",
              px: 3,
              py: 1.25,
              fontSize: "0.75rem",
              letterSpacing: "0.1em",
              "&:hover": { bgcolor: "#333" },
            }}
          >
            Admin Dashboard
          </Button>
        )}
        <Button
          onClick={handleSignOut}
          variant="outlined"
          sx={{
            borderColor: "#d4d4d4",
            color: "#737373",
            px: 3,
            py: 1.25,
            fontSize: "0.75rem",
            letterSpacing: "0.1em",
            "&:hover": { borderColor: "black", color: "black" },
          }}
        >
          Sign Out
        </Button>
      </Box>
    </Box>
  );
};

export default AccountPage;
